module.exports = __webpack_public_path__ + "static/media/logoTransparent.9ef50635.svg";